import React from 'react';
import { Instagram, Twitter, Linkedin } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { socialLinks } from '../data/mockData';

const Footer = () => {
  const { isDark } = useTheme();

  const iconMap = {
    Instagram: Instagram,
    Twitter: Twitter,
    LinkedIn: Linkedin
  };

  return (
    <footer className="site-footer">
      <div className="footer-social-icons">
        {socialLinks.map((link) => {
          const IconComponent = iconMap[link.name];
          return (
            <a
              key={link.id}
              href={link.url}
              className="footer-social-icon"
              aria-label={link.name}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconComponent size={18} />
            </a>
          );
        })}
      </div>
      <p className="footer-text">
        Forged with ❤️ in Thunder Bluff, Mulgore.
      </p>

      <style jsx>{`
        .site-footer {
          margin-top: 32px;
          padding-top: 16px;
          padding-bottom: 16px;
          border-top: 1px solid ${isDark ? 'rgba(182, 180, 189, 0.1)' : 'rgba(0, 0, 0, 0.08)'};
          text-align: center;
        }

        .footer-social-icons {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 16px;
          margin-bottom: 12px;
        }

        .footer-social-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: transparent;
          color: ${isDark ? '#998f8f' : '#64748b'};
          transition: all 0.2s ease;
        }

        .footer-social-icon:hover {
          color: #f46c38;
          background: rgba(244, 108, 56, 0.1);
          transform: translateY(-2px);
        }

        .footer-text {
          font-family: 'Poppins', sans-serif;
          font-size: 13px;
          color: ${isDark ? '#998f8f' : '#64748b'};
          margin: 0;
          text-align: center;
        }
      `}</style>
    </footer>
  );
};

export default Footer;
